export const AMAZON_AD_AFFILIATE_TYPE = 'Amazon Affiliate Ad - JS';
